import { TefComs4p } from '@mfe/components/TefComs4p';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single user bound purpose in EDIT mode
//
export const singlePurposeUserBoundEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <one-section size="xxs" background="muted-2">
      <one-heading level="h6" variant="default">Vertragsinhaber</one-heading>
    </one-section>

    <one-stack gap="xs">
      ${purpose.apps!.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <one-checkbox ?checked="${!purpose.apps!.some((app) => app.granted)}" @change=${() => { this.revokeAllAppConsentsForPurpose(purpose); }}>
        <one-text size="lg">Alle deaktivieren</one-text>
      </one-checkbox>
    </one-stack>
  `;
};
